import { render, staticRenderFns } from "./MoveOrderToDifferentTripSelect.vue?vue&type=template&id=87048568&scoped=true&"
import script from "./MoveOrderToDifferentTripSelect.vue?vue&type=script&lang=js&"
export * from "./MoveOrderToDifferentTripSelect.vue?vue&type=script&lang=js&"
import style0 from "./MoveOrderToDifferentTripSelect.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MoveOrderToDifferentTripSelect.vue?vue&type=style&index=1&id=87048568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87048568",
  null
  
)

/* custom blocks */
import block0 from "./MoveOrderToDifferentTripSelect.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports